import React from 'react'

const CardAmount = ({label,amountValue,footerValue}) => {
    return (
        <div id='total' className=' flex-1 text-center'>
            <div className=' text-[#251658] text-xs'>{label}</div>
            { !!amountValue && 
                <div className='text-xs flex flex-col gap-2' >
                    <div className='font-bold text-base text-slate-600  '>{amountValue}</div>
                    <div className='text-[#251658]'>{!!footerValue && footerValue}</div>
                </div>
            }
        </div>
    )
}

export default CardAmount